/* eslint-disable max-len */
import React from 'react'
import { Accordion } from 'react-bootstrap'
import DataGridComponent from '@components/common/DataGridComponent/DataGridComponent'
import StatusBadge, {
  StatusTypes,
} from '@components/common/StatusBadge/StatusBadge.component'
import Button from '@components/common/Button/Button.component'

type TrackerTableProps = {
  trackerData: {
    id: string
    title: string
    count: number
    timeDuration?: string
    patientName?: string
    providerName?: string
    status?: StatusTypes
  }[]
}

const TrackerTable: React.FC<TrackerTableProps> = ({ trackerData }) => {
  const getTitleClass = (title: string): string => {
    switch (title) {
      case 'Scheduled':
        return 'bg-scheduled'
      case 'Checked-in':
        return 'bg-checked-in'
      case 'In Treatment':
        return 'bg-in-treatment'
      case 'Discharged':
        return 'bg-discharged'
      default:
        return ''
    }
  }

  const columns = [
    {
      field: 'timeDuration',
      headerText: 'Time',
      width: '120',
      textAlign: 'Left' as const,
    },
    {
      field: 'patientName',
      headerText: 'Patient Name',
      width: '150',
      textAlign: 'Left' as const,
    },
    {
      field: 'providerName',
      headerText: 'Provider',
      width: '150',
      textAlign: 'Left' as const,
    },
    {
      field: 'status',
      headerText: 'Alerts',
      width: '100',
      textAlign: 'Left' as const,
      template: (props: any) => <StatusBadge status={props.status} />,
    },
    {
      field: '',
      headerText: 'Actions',
      width: '150',
      textAlign: 'Center' as const,
      template: () => (
        <div className="action-buttons">
          <Button className="action-button">
            <i className="ti ti-phone-filled"></i>
          </Button>
          <Button className="action-button">
            <i className="ti ti-mail-filled"></i>
          </Button>
          <Button className="action-button">
            <i className="ti ti-message-filled"></i>
          </Button>
          <Button className="action-button">
            <i className="ti ti-dots-vertical"></i>
          </Button>
        </div>
      ),
    },
  ]

  return (
    <Accordion
      defaultActiveKey={trackerData.length > 0 ? [trackerData[0].id] : null}
    >
      {trackerData.map((tracker) => (
        <Accordion.Item
          eventKey={tracker.id}
          key={tracker.id}
          className="border-0"
        >
          <Accordion.Header
            className={`d-flex justify-content-between align-items-center w-100 ${getTitleClass(tracker.title)}`}
          >
            <span className="tracker-title">{tracker.title}</span>
            <span className="tracker-count">{tracker.count}</span>
          </Accordion.Header>
          <Accordion.Body className="no-padding tracker-table-body">
            {tracker.count > 0 ? (
              <div className="hide-vertical-borders">
                <DataGridComponent
                  data={[tracker]}
                  columns={columns}
                  pageSize={1}
                />
              </div>
            ) : (
              <div className="no-data text-center">No data available</div>
            )}
          </Accordion.Body>
        </Accordion.Item>
      ))}
    </Accordion>
  )
}

export default TrackerTable
